export const MultipleWifiNetworksEquipmentEnum = [
  'OXIAD-TPLHB610',
  'OXWIFI-TLHB610W7',
  'OXIAD-TPAGHB210P',
  'OXIAD-TPAGXB230P'
]



// WEBPACK FOOTER //
// ./src/assets/js/Enum/MultipleWifiNetworksEquipmentEnum.js